import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterParticipant({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    email: "",
    name: "",
    group: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.email) {
      condition.email = {
        $regex: filter.email.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.name) {
      condition.name = {
        $regex: filter.name.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.group) {
      condition.group_id = filter.group._id;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Tài khoản"
        placeholder="Tìm theo tài khoản"
        value={filter.email}
        onSearch={(val) => setFilter({ ...filter, email: val })}
      />
      <FilterText
        direction="column"
        label="Tên"
        placeholder="Tìm theo tên"
        value={filter.name}
        onSearch={(val) => setFilter({ ...filter, name: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Nhóm người dùng"
        placeholder="Chọn nhóm người dùng"
        selectTitle="Chọn nhóm người dùng"
        placeholderSearch="Tìm theo tên nhóm"
        apiCode="usergroup"
        searchFields={["group_name"]}
        value={filter.group}
        onChange={(val) => setFilter({ ...filter, group: val })}
        getOptionLabel={(option) => option.group_name}
        checkEqual={(value, option) => value._id === option._id}
      />
    </WrapperFilter>
  );
}

export default FilterParticipant;
